import { render, staticRenderFns } from "./paper.vue?vue&type=template&id=22c2ea4c"
import script from "./paper.vue?vue&type=script&lang=js"
export * from "./paper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports